import React from 'react';
var Shape = props => /*#__PURE__*/React.createElement("path", props);
export default Shape;
//# sourceMappingURL=index.js.map